export function initializeFAQBlock() {
    // wait 1 sec because it somehow needs it before accurrate calculations are available.
    setTimeout(() => {

        // Opening and closing of FAQ items
        const expandables = document.querySelectorAll('div.faq-block div.faq-expandable')

        if (!expandables[0]) return

        const closedHeight = (element) => element.offsetHeight

        const toggleExpandable = (expandable) => {
            const title = expandable.querySelector('div.summary p')
            const classList = expandable.classList
            const isOpen = expandable.classList.contains('open')

            isOpen ? classList.remove('open') : classList.add('open')
            expandable.style.height = `${isOpen ? closedHeight(title) : expandable.originalHeight}px`
        }

        for (let i = 0; i < expandables.length; i++) {
            const expandable = expandables[i]
            const summary = expandable.querySelector('div.summary')
            const title = summary.querySelector('p')

            expandable.originalHeight = expandable.offsetHeight
            expandable.style.height = `${closedHeight(title)}px`
            summary.addEventListener('click', (e) => toggleExpandable(expandable))
        }

        window.addEventListener('resize', (e) => {
            for (let i = 0; i < expandables.length; i++) {
                const expandable = expandables[i]

                if (!expandable.classList.contains('open')) {
                    const title = expandable.querySelector('div.summary p')
                    expandable.style.height = `${closedHeight(title)}px`
                }
            }
        })

        // Show/hide FAQ's of particular category 
        const toggleCategories = (category) => {
            const alias = category.getAttribute('href').substr(1);

            for (let i = 0; i < expandables.length; i++) {
                const expandable = expandables[i]
                const aliasses = expandable.getAttribute('data-category').split('/')

                const found = aliasses.find(item => item === alias) === alias;
                found ? expandable.classList.remove('hide') : expandable.classList.add('hide')
            }
        }

        const categories = document.querySelectorAll('div.faq-block div.faq-categories a')
        for (let i = 0; i < categories.length; i++) {
            const category = categories[i]
            category.addEventListener('click', (e) => toggleCategories(category))
        }
    }, 200)
}
